var MAX_TIME_DIFFERENCE_MINUTES = 10;
/**
 * Determines whether to auto-open the most recent chat based on timing
 * @param chatHistory - Array of chat history items (should be sorted by most recent first)
 * @returns AutoOpenResult with decision and metadata
 *
 * @example
 * // Test with recent chat (should auto-open)
 * const recentChat = [{ id: '1', title: 'Test', updatedAt: new Date(Date.now() - 5 * 60 * 1000).toISOString() }];
 * const result = shouldAutoOpenRecentChat(recentChat);
 * // result: { shouldAutoOpen: true, chatId: '1' }
 *
 * @example
 * // Test with old chat (should not auto-open)
 * const oldChat = [{ id: '1', title: 'Test', updatedAt: new Date(Date.now() - 15 * 60 * 1000).toISOString() }];
 * const result = shouldAutoOpenRecentChat(oldChat);
 * // result: { shouldAutoOpen: false, chatId: '1' }
 */
export var shouldAutoOpenRecentChat = function (chatHistory) {
    if (!chatHistory || chatHistory.length === 0) {
        return {
            shouldAutoOpen: false,
        };
    }
    var mostRecentChat = chatHistory[0];
    var now = new Date();
    var lastChatTime = new Date(mostRecentChat.updatedAt);
    var timeDifferenceMinutes = (now.getTime() - lastChatTime.getTime()) / (1000 * 60);
    if (timeDifferenceMinutes < MAX_TIME_DIFFERENCE_MINUTES) {
        return {
            shouldAutoOpen: true,
            chatId: mostRecentChat.id,
        };
    }
    return {
        shouldAutoOpen: false,
        chatId: mostRecentChat.id,
    };
};
